// Brigade crest — a small top-left overlay badge on the Live Map. Absolutely
// positioned within the map container (same pattern as the map-type selector /
// legend), sitting clear of the map-type buttons at both desktop and mobile.
export default function BrigadeCrest() {
  return (
    <div
      className={[
        'absolute top-2 left-2 lg:top-4 lg:left-4 z-[1100]',
        'rounded-lg p-1 bg-command-bg/85 backdrop-blur-sm',
        'border border-command-border ring-1 ring-command-accent/25',
        'shadow-lg shadow-black/50',
      ].join(' ')}
      aria-label="Brigade crest"
      title="Brigade"
    >
      <img
        src="/logo.png"
        alt="Brigade crest"
        width={44}
        height={44}
        className="h-10 w-10 lg:h-11 lg:w-11 object-contain select-none pointer-events-none"
        draggable={false}
      />
    </div>
  );
}
